import React from 'react';
import ReactDOM from 'react-dom';
import '../styles/public.scss';

import SearchWrapper from './components/SearchWrapper';

document.addEventListener('DOMContentLoaded', () => {
  const searchElement = document.getElementById('uu-provider-search-container');
  if (searchElement) {
    ReactDOM.render(<SearchWrapper />, searchElement);
  }
});



// WEBPACK FOOTER //
// ./public/js/index.jsx